<template>

  <div class="d-md-flex justify-space-between align-center">

    <div class="d-flex align-center">

      <v-btn :text="$t('titles.today')" @click="model = Temporal.Now.plainDateISO()" :disabled="disabled" />

      <div class="ml-4">

        <v-btn-group>
          <v-btn icon="$calendarPrev" @click="prev()" :disabled="disabled" />
          <v-btn icon="$calendarNext" @click="next()" :disabled="disabled" />
        </v-btn-group>

      </div>

      <div class="ml-4 text-h5">
        {{ calendar?.title }}
      </div>

    </div>

    <div class="mt-8 mt-md-0">
      <slot />
    </div>

  </div>

</template>

<script setup lang="ts">

import NormalizedCalendar from './NormalizedCalendar.vue'
import { Temporal } from '@js-temporal/polyfill'

type VCalendarType = InstanceType<typeof NormalizedCalendar>

interface Props {
  calendar: null | VCalendarType // template ref to the VCalendar component
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const model = defineModel<Temporal.PlainDate>({ required: true })

function prev() {
  if (props.calendar?.prev) {
    props.calendar.prev()
  }
}

function next() {
  if (props.calendar?.next) {
    props.calendar.next()
  }
}

</script>
